import { getStoreRelatedById } from "api/purchaseRequest/purchaseRequest";
import Card from "components/Card/Card";
import React, { useEffect, useState, useRef } from "react";
import {
  Col,
  Grid,
  Row,
  Table,
  FormControl,
  Button,
  Pagination,
} from "react-bootstrap";
import NotificationSystem from "react-notification-system";
import ScreenLoader from "views/Components/screenLoader";
import LoadingSpinner from "views/Components/loadingSpinner";
import Select from "react-select";
import { getAllStoresByCountryCode } from "api/warehouseInventoryDispatch/warehouseInventoryDispatch";
const GetRelatedStore = (props) => {
  var token = JSON.parse(localStorage.getItem("user"));
  const obj = token.token;
  const id = token.store_id;
  const role = token.role;

  const _notificationSystem = useRef();
  // const [id, setId] = useState(null);
  const [relatedStores, setRelatedStores] = useState([]);
  const [filterByStore, setFilterByStore] = useState("");
  const [loading, setLoading] = useState(false);
  const [searchByFCode, setSearchByFCode] = useState("");
  const [searchByMedicationTitle, setSearchByMedicationTitle] = useState("");
  const [searchByGenericName, setSearchByGenericName] = useState("");
  const [getAllStores, setGetAllStores] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);

  useEffect(() => {
    getStoreById();
    fetchAllStores();
    const user = JSON.parse(localStorage.getItem("user"));
    // if (user && user.store_id) {
    //   setId(user.store_id);
    // }
  }, [
    id,
    searchByMedicationTitle,
    searchByFCode,
    searchByGenericName,
    currentPage,
    filterByStore,
  ]);

  const handleSearchByCode = (event) => {
    const value = event.target.value;
    setSearchByFCode(value);
  };
  const handleSearchByMedicationTitle = (event) => {
    const value = event.target.value;
    setSearchByMedicationTitle(value);
  };
  const handleSearchByGenericName = (event) => {
    const value = event.target.value;
    setSearchByGenericName(value);
  };
  let items = [];
  for (let number = 1; number <= totalPage; number++) {
    items.push(
      <Pagination.Item
        key={number}
        onClick={() => setCurrentPage(number)}
        active={number === currentPage}
      >
        {number}
      </Pagination.Item>,
    );
  }

  const fetchAllStores = async () => {
    const countryCode = "LK";
    try {
      const response = await getAllStoresByCountryCode(countryCode, obj);
      const stores = response.data.map((store) => {
        return {
          value: store.id,
          label: store.name,
        };
      });
      setGetAllStores(stores);
    } catch (error) {
      console.error("Error fetching stores:", error);
      return [];
    }
  };

  const getStoreById = () => {
    setLoading(true);
    const is_show_all_medicine = role !== 1 && role !== 2 ? 0 : 1;
    const storeFilterValue =
      role === 1 || role === 2
        ? filterByStore
          ? filterByStore.value
          : ""
        : "";
    getStoreRelatedById(
      obj,
      id ? id : "",
      searchByMedicationTitle,
      searchByFCode,
      searchByGenericName,
      currentPage,
      storeFilterValue,
      is_show_all_medicine,
    )
      .then((res) => {
        if (res && res.data) {
          setRelatedStores(res.data);
          setCurrentPage(res.pagination && res.pagination.current_page);
          setTotalPage(res.pagination.last_page);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log("Error fetching custom utility data:", err);
        setLoading(false);
      });
  };
  const resetValue = () => {
    setSearchByMedicationTitle("");
    setSearchByFCode("");
    setSearchByGenericName("");
    setFilterByStore(null);
  };

  const addInventory = () => {
    props.history.push("/admin/inventory");
  };

  return (
    <>
      <NotificationSystem ref={_notificationSystem} />
      <Grid fluid>
        <br />
        <Card
          tableFullWidth
          content={
            <>
              <div
                className="warehouse-inventory-filter"
                style={{
                  margin: "10px",
                  padding: "10px",
                  border: "1px dashed grey",
                  borderRadius: "10px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: "15px",
                    flexWrap: "wrap",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "15px",
                      flexWrap: "wrap",
                    }}
                  >
                    <FormControl
                      name="searchByFCode"
                      placeholder="Search By Item Code"
                      type="text"
                      className="text-input"
                      value={searchByFCode}
                      onChange={(event) => handleSearchByCode(event)}
                      style={{ width: "220px" }}
                    />
                    <FormControl
                      name="searchByTitle"
                      placeholder="Search By Medication Title"
                      type="text"
                      className="text-input"
                      value={searchByMedicationTitle}
                      onChange={(event) => handleSearchByMedicationTitle(event)}
                      style={{ width: "220px" }}
                    />
                    <FormControl
                      name="searchByGenericName"
                      placeholder="Search By Generic Name"
                      type="text"
                      className="text-input"
                      value={searchByGenericName}
                      onChange={(event) => handleSearchByGenericName(event)}
                      style={{ width: "220px" }}
                    />

                    <Button
                      className="fl_mb_web_1 btn-fill fl_mb_1"
                      onClick={resetValue}
                    >
                      Reset
                    </Button>
                    {role === 1 || role === 2 ? (
                      <Select
                        options={getAllStores}
                        isClearable
                        onChange={(selectedOption) =>
                          setFilterByStore(selectedOption ? selectedOption : "")
                        }
                        placeholder="Select Store"
                        value={filterByStore}
                        styles={{
                          container: (base) => ({ ...base, width: "220px" }),
                        }}
                      />
                    ) : (
                      ""
                    )}
                  </div>
                  <Button
                    className="btn-fill"
                    class="btn-color "
                    fill
                    onClick={addInventory}
                  >
                    Add Inventory<i className="fa fa-plus"></i>
                  </Button>
                </div>
              </div>
              <br />
              <Row>
                <Col
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  style={{ padding: "28px" }}
                >
                  {loading ? (
                    <LoadingSpinner />
                  ) : (
                    <Table responsive>
                      <thead>
                        <tr>
                          <th>item_code</th>
                          <th>medication title</th>
                          <th>quantity</th>
                          <th>Placement</th>
                          <th>buying price</th>
                          <th>selling price</th>
                        </tr>
                      </thead>
                      <tbody>
                        {relatedStores && relatedStores.length > 0 ? (
                          relatedStores &&
                          relatedStores.map((item) => (
                            <tr key={item.id}>
                              <td>{item.item_code}</td>
                              <td>{item.medication_title}</td>
                              <td>{item.quantity}</td>
                              <td>
                                {item.ycoord}
                                {item.xcoord}
                              </td>
                              <td>{item.buying_price}</td>
                              <td>{item.selling_price}</td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="9" style={{ textAlign: "center" }}>
                              No related Data found.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  )}
                </Col>
              </Row>
              <div style={{ textAlign: "center" }}>
                <Pagination bsSize="medium">{items}</Pagination>
              </div>
            </>
          }
        />
      </Grid>
    </>
  );
};

export default GetRelatedStore;
